var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJudgementGiven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7776 3.47149C11.9297 3.3194 12.1763 3.3194 12.3284 3.47149L14.1331 5.27627C14.2852 5.42835 14.2852 5.67493 14.1331 5.82702L10.0482 9.91195C9.89613 10.064 9.64955 10.064 9.49746 9.91195L7.69268 8.10717C7.54059 7.95508 7.54059 7.7085 7.69268 7.55642L11.7776 3.47149ZM13.389 2.41083C12.6511 1.67295 11.4548 1.67295 10.7169 2.41083L6.63202 6.49576C5.89415 7.23363 5.89415 8.42996 6.63202 9.16783L8.4368 10.9726C9.17467 11.7105 10.371 11.7105 11.1089 10.9726L12.6271 9.4544L17.2268 14.0541C17.5197 14.347 17.9946 14.347 18.2875 14.0541C18.5804 13.7612 18.5804 13.2864 18.2875 12.9935L13.6877 8.39374L15.1938 6.88768C15.9317 6.14981 15.9317 4.95348 15.1938 4.21561L13.389 2.41083ZM4.67285 13.1262C3.70636 13.1262 2.92285 13.9097 2.92285 14.8762V16.7017H2.24268C1.82846 16.7017 1.49268 17.0375 1.49268 17.4517C1.49268 17.8659 1.82846 18.2017 2.24268 18.2017H3.67285H12.5388H13.969C14.3832 18.2017 14.719 17.8659 14.719 17.4517C14.719 17.0375 14.3832 16.7017 13.969 16.7017H13.2888V14.8762C13.2888 13.9097 12.5053 13.1262 11.5388 13.1262H4.67285ZM11.7888 16.7017H4.42285V14.8762C4.42285 14.7382 4.53478 14.6262 4.67285 14.6262H11.5388C11.6769 14.6262 11.7888 14.7382 11.7888 14.8762V16.7017Z",
    fill: "#52CC8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudgementGiven);
export default __webpack_public_path__ + "static/media/judgement-given.34fdeefc41fc3c859a5f81655b9e9600.svg";
export { ForwardRef as ReactComponent };